import React, { useEffect, useState } from "react";
import { Box, TextField, Autocomplete } from "@mui/material";
import {
  AUTOCOMPLETE_TYPING_DELAY_IN_MS,
  //   DEFAULT_LAT_FOR_PLACE_SEARCH,
  //   DEFAULT_LON_FOR_PLACE_SEARCH,
} from "models/constants";

const startTyping = "Type at least 3 characters";
const minSearchLength = 3;

export default function PracticeSelector({
  id,
  value,
  setValue,
  sx = {},
  error = "",
  publicMode = false,
  recipientsOnly = false,
  setError,
}) {
  const [list, setList] = useState([]);
  const [search, setSearch] = useState("");
  const [noOptionsText, setNoOptionsText] = useState(startTyping);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);

  // const [lon, setLon] = useState(DEFAULT_LON_FOR_PLACE_SEARCH);
  // const [lat, setLat] = useState(DEFAULT_LAT_FOR_PLACE_SEARCH);

  const handleChange = async (e) => {
    const value = e?.target?.value ?? "";
    setSearch(value);
  };

  const handleSelect = (e, option) => {
    if (setValue) {
      setValue(option ?? { id: "", name: "" });
    }
  };

  const handleClose = (option) => {
    setSearch("");
    setList([]);
  };

  const loadList = async (search) => {
    let result;
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/organization_autocomplete`,
        {
          method: "POST",
          body: JSON.stringify({
            search,
            recipientsOnly,
          }),
        }
      );
      result = await response.json();
    } catch (error) {
      setIsLoading(false);
      setIsLoaded(true);
      console.error(error);
      setError(error);
      return;
    }

    if (result?.error) {
      setIsLoading(false);
      setIsLoaded(true);
      console.error(result.error);
      setError(result.error);
      return;
    }
    setList(
      result?.records?.map(({ id, name, speciality, phone }) => ({
        id,
        name: [name, speciality, phone].filter(Boolean).join(", "),
      })) ?? []
    );
    setIsLoading(false);
    setIsLoaded(true);
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      setIsLoaded(false);
      if (search?.length > 2) {
        setIsLoading(true);
        loadList(search);
        return;
      }

      if (!search || search === "" || search?.length < minSearchLength) {
        setList([]);
      }
    }, AUTOCOMPLETE_TYPING_DELAY_IN_MS);

    return () => clearTimeout(timeout);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  useEffect(() => {
    let timeout;

    if (isLoading) {
      setNoOptionsText("Loading...");
      return;
    }
    if (search.length < minSearchLength) {
      setNoOptionsText("Type at least 3 characters");
      return;
    }
    if (isLoaded && list.length === 0) {
      setNoOptionsText("Loading...");
      timeout = setTimeout(() => {
        setNoOptionsText("No results found");
      }, 1500);
      return;
    }
    setNoOptionsText("");

    return () => clearTimeout(timeout);
  }, [list, isLoaded, isLoading, search]);

  return (
    <Autocomplete
      id={id}
      sx={{ width: "100%", ...sx }}
      value={value}
      options={list}
      noOptionsText={noOptionsText}
      getOptionLabel={(option) => option.name}
      filterOptions={(options) => options}
      renderOption={(props, option) => (
        <Box
          component="li"
          sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
          {...props}
        >
          {option.name}
        </Box>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder="Start typing practice name..."
          inputProps={{
            ...params.inputProps,
            autoComplete: "new-password", // disable autocomplete and autofill
            form: {
              autoComplete: "new-password",
            },
          }}
          InputProps={{
            ...(params?.InputProps ?? {}),
            autoComplete: "off",
          }}
          onChange={handleChange}
          error={!!error}
          // @ts-ignore
          helperText={error}
          autoComplete="new-password"
        />
      )}
      autoHighlight
      onChange={handleSelect}
      onClose={handleClose}
      onInputChange={handleChange}
      clearOnEscape
      autoComplete
    />
  );
}
